// extracted by mini-css-extract-plugin
module.exports = {"cardCarouselLoader":"cardCarouselLoader_cardCarouselLoader__MOJEF"};